import { useContext, useEffect, useState } from 'react'
import { getFaqs } from '../services/faq.service'
import { faqType } from '../types'
import { TenantsContext } from '../../../context/tenants.context'
import { useDeviceId } from '../../../hooks/deviceId.hook'

export const useFaq = () => {
  const [faqs, setFaqs] = useState<faqType[]>([])
  const { tenant } = useContext(TenantsContext)
  const { deviceId, loading } = useDeviceId()

  useEffect(() => {
    if (!loading)
      getFaqs(tenant, deviceId).then((res) => {
        setFaqs(res.data.faq)
      })
  }, [])

  return { faqs }
}
